import { render, staticRenderFns } from "./LoadingMore.vue?vue&type=template&id=28cbe3b8&scoped=true"
import script from "./LoadingMore.vue?vue&type=script&lang=js"
export * from "./LoadingMore.vue?vue&type=script&lang=js"
import style0 from "./LoadingMore.vue?vue&type=style&index=0&id=28cbe3b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28cbe3b8",
  null
  
)

export default component.exports